import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["view", "onCancel", "invokeMethod"];
import React, { useCallback, useMemo } from 'react';
import { LinkPicker } from '@atlaskit/link-picker';
import { hideLinkToolbar as cardHideLinkToolbar } from '../../../card/pm-plugins/actions';
import { hideLinkToolbar } from '../../commands';
import { useEscapeClickaway } from './useEscapeClickaway';
import { AnalyticsContext } from '@atlaskit/analytics-next';

/**
 * Returns a type that matches T but where keys (K) are now optional
 */

export var EditorLinkPicker = function EditorLinkPicker(_ref) {
  var view = _ref.view,
    onCancel = _ref.onCancel,
    _ref$invokeMethod = _ref.invokeMethod,
    invokeMethod = _ref$invokeMethod === void 0 ? '_unknown' : _ref$invokeMethod,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onEscape = useCallback(function () {
    hideLinkToolbar()(view.state, view.dispatch);
    view.dispatch(cardHideLinkToolbar(view.state.tr));
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  }, [view, onCancel]);
  var onClickAway = useCallback(function () {
    hideLinkToolbar()(view.state, view.dispatch);
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  }, [view, onCancel]);
  var ref = useEscapeClickaway(onEscape, onClickAway);
  var analyticsData = useMemo(function () {
    return {
      attributes: {
        invokeMethod: invokeMethod
      }
    };
  }, [invokeMethod]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: analyticsData
  }, /*#__PURE__*/React.createElement(LinkPicker, _extends({}, restProps, {
    onCancel: onEscape
  }))));
};